import React from 'react';

function About() {
  return (
    <div>
      hi im linsey and this is about me

      software engineer
      passion for accessibility

    </div>
  )
}

export default About;